var render = function render(){var _vm=this,_c=_vm._self._c;return _c('adv-button-view-buy-picker',{attrs:{"show-quick-view":false,"product-id":_vm.productId,"product-code-id":_vm.productCodeId,"is-listing":false,"is-variation-group-master":false,"unavailable-product":_vm.unavailableProduct,"recommendation-type":_vm.recommendationType,"recommendation-id":_vm.recommendationId}})
}
var staticRenderFns = []

export { render, staticRenderFns }